import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'storeFilterCount',
  pure: false,
})
export class StoreFilterCountPipe implements PipeTransform {
  transform(value: Array<any> = [], obj: any, fn: string): any {
    obj[fn] = value.length;
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/storeFilterCount.pipe.ts